import {
  listAccountIds as publicListAccountIds,
  businessStatus as publicBusinessStatus,
  estimateDelivery as publicEstimateDelivery,
  createDelivery as publicCreateDelivery,
} from './localdelivery-spi-v1-tpa-local-delivery-spi.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listAccountIds: MaybeContext<
  BuildRESTFunction<typeof publicListAccountIds> & typeof publicListAccountIds
> = /*#__PURE__*/ createRESTModule(publicListAccountIds);
export const businessStatus: MaybeContext<
  BuildRESTFunction<typeof publicBusinessStatus> & typeof publicBusinessStatus
> = /*#__PURE__*/ createRESTModule(publicBusinessStatus);
export const estimateDelivery: MaybeContext<
  BuildRESTFunction<typeof publicEstimateDelivery> &
    typeof publicEstimateDelivery
> = /*#__PURE__*/ createRESTModule(publicEstimateDelivery);
export const createDelivery: MaybeContext<
  BuildRESTFunction<typeof publicCreateDelivery> & typeof publicCreateDelivery
> = /*#__PURE__*/ createRESTModule(publicCreateDelivery);

export { BusinessStatus } from './localdelivery-spi-v1-tpa-local-delivery-spi.universal.js';
export {
  Tpa,
  ListAccountIdsRequest,
  ListAccountIdsResponse,
  BusinessStatusRequest,
  BusinessStatusResponse,
  EstimateDeliveryRequest,
  EstimateDeliveryRequestDispatchTimeOneOf,
  Address,
  StreetAddress,
  AddressLocation,
  Money,
  EstimateDeliveryResponse,
  CreateDeliveryRequest,
  CreateDeliveryRequestDispatchTimeOneOf,
  Customer,
  CreateDeliveryResponse,
  BusinessStatusOptions,
  EstimateDeliveryOptions,
  EstimateDeliveryOptionsDispatchTimeOneOf,
  CreateDeliveryOptions,
  CreateDeliveryOptionsDispatchTimeOneOf,
} from './localdelivery-spi-v1-tpa-local-delivery-spi.universal.js';
export {
  BusinessStatusWithLiterals,
  EstimateDeliveryApplicationErrors,
  CreateDeliveryApplicationErrors,
} from './localdelivery-spi-v1-tpa-local-delivery-spi.universal.js';
